/* eslint-disable no-unused-vars */
export enum Slanted {
  BOTTOM = 'bottom-inclined',
  REVERSE_BOTTOM = 'reverse-bottom-inclined',
  V = 'v-bottom',
  NONE = 'none',
}
